export default function camelCaseToSnakeCase(value: string): string {
  return value.split(/(?=[A-Z])/).join('-').toLowerCase();
}
